/*global google*/
import React, { useState, useEffect, useMemo, useRef } from 'react';
import axios from "axios";

import AdminHeaderNew from '../Common/AdminHeader';
import AdminSideBarNew from '../Common/AdminSideBar';
import AdminSideBarMnt from '../Common/AdminSidebarMnt';
import AdminFooterNew from '../Common/AdminFooter';
import '../../../assets/styles/Style.css';
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";



function SelfAssignTargetMNT() {

    const [latestSurveyCount, setLatestSurveyCount] = useState([]);
    const [expandedRowIndex, setExpandedRowIndex] = useState(null);
    const [statesData, setStatesData] = useState([]);
    const [assignTargetListing, setAssignTargetListing] = useState([]);
    const [targetPlaceholder, setTargetPlaceholder] = useState("000000");
    //const [revisedTargetPlaceholder, setRevisedTargetPlaceholder] = useState("000000");
    const [assignDistrictTarget, setAssignDistrictTarget] = useState("");
    const [assignSubDistrictTarget, setAssignSubDistrictTarget] = useState("");
    const [assignTarget, setAssignTarget] = useState("");
    const [missionTargetSummary, setMissionTargetSummary] = useState([]);
    const [summaryString, setSummaryString] = useState('');

    //const [revisedTarget, setRevisedTarget] = useState("");
    const [stateValue, setStateValue] = useState('');
    const [subDistrictValues, setSubDistrictValues] = useState('');
    const [revisedByState, setRevisedByState] = useState('');
    const [revisedTargetByState, setRevisedTargetByState] = useState('');
    const [villageCode, setVillageCode] = useState('');

    const [finYear, setFinYear] = useState(() => {
        // read default from sessionStorage; fallback to 2024-2025
        const stored = sessionStorage.getItem("finYear");
        return stored && (stored === "2024-2025" || stored === "2025-2026") ? stored : "2025-2026";
    });
    // const finYearStatic = getCurrentFinancialYear();
    const finYearStatic = "2025-2026";
    const schemeCode = sessionStorage.getItem("schemeCodeModel");
    const currentSchemeName = sessionStorage.getItem("currentSchemeName");
    const currentStateName = sessionStorage.getItem("currentStateName");
    const currentDistrictName = sessionStorage.getItem("currentDistrictName");
    const [districtValue, setDistrictValue] = useState('');
    const [subDistrictData, setSubDistrictData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [showTargetInput, setShowTargetInput] = useState(false);
    const userType = sessionStorage.getItem("userRoleCodeModel");
    const [expandedRowData, setExpandedRowData] = useState([]);
    const [assignedTargetArry, setAssignedTargetArry] = useState([]);

    const [ddlSubTypeList, setDDlSubTypeList] = useState([]);
    const [txtlType, setTxtlType] = useState("");
    const [selectedValue, setSelectedValue] = useState('');

    //const [otherText, setOtherText] = useState('');
    const [rows, setRows] = useState([]);
    // const lastSerializedRef = useRef('');
    const [rowValues, setRowValues] = useState([]);
    const [optionVillage, setOptionVillage] = useState([]);
    const [isStateRevised, setIsStateRevised] = useState(false);
    const [isYesButtonDisabled, setIsYesButtonDisabled] = useState(false);
    const [assignTargetReports, setAssignTargetReports] = useState([]);
    const [selfAssignedTargetRecords, SetSelfAssignedTargetRecords] = useState([]);
    const [activeRow, setActiveRow] = useState(null);   // which row is opened
    const [inputValue, setInputValue] = useState("");   // input text
    const [achievedValues, setAchievedValues] = useState({});

    const [selectedTypeData, setSelectedTypeData] = useState({
        revisedTargetByState: '',
        centralMission: '',
        districtName: '',
        districtMission: ''
    });
    const [groupedSchemeData, setGroupedSchemeData] = useState([]);

    // Pagination state variables
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage] = useState(10);

    const handleFinYearChange = (e) => {
        const value = String(e.target.value || "");
        sessionStorage.setItem("finYear", value);
        setFinYear(value);
        assignTargetData();
        // console.log('getCurrentFinancialYear: ',getCurrentFinancialYear());
    };


    const handleRowClearVillage = () => {
        // Reset the SubType select
        setSelectedValue('');

        // Reset the selected type data
        setSelectedTypeData({
            revisedTargetByState: '',
            centralMission: ''
        });

        // Clear village options
        setOptionVillage([]);

        // Reset the row values (Village and Assign Target)
        setRowValues(prev =>
            prev.map((row, i) => ({
                ...row,
                villageValue: "",
                targetValue: ""
            }))
        );
    };

    function getCurrentFinancialYear() {
        const today = new Date();
        let year = today.getFullYear();

        // If month is Jan, Feb, or Mar (0 = Jan), financial year starts from previous year
        if (today.getMonth() < 3) {
            return `${year - 1}-${year}`;
        } else {
            return `${year}-${year + 1}`;
        }
    }

    const handleRowClearSubDistrict = () => {
        // Reset the SubType select
        setSelectedValue('');

        // Reset the selected type data
        setSelectedTypeData({
            revisedTargetByState: '',
            centralMission: ''
        });
    };

    // Pagination functions
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;

    const handleSubmitAchieved = async (index, item) => {
        //alert(sessionStorage.getItem("userCodeModel")) ;
        const newValue = Number(achievedValues[index] || 0) + Number(inputValue);
        console.log("item", item);
        console.log("item.id", item.id);
        // 1️⃣ Update UI instantly
        setAchievedValues({
            ...achievedValues,
            [index]: newValue,
        });

        // 2️⃣ Clear UI
        setActiveRow(null);
        setInputValue("");

        // 3️⃣ Prepare API Data
        const payload = {
            Id: item.id,                   // <-- item.id from table
            PhysicalAchievment: newValue, // <-- achieved total
            UserId: sessionStorage.getItem("userCodeModel"),              // <-- your logged-in userId
        };

        try {
            const response = await fetch(
                "https://km.amnex.co.in/appdevapi/api/MissionTarget/MissionTarget/Insert_MissionTarget_PhysicalAchievement",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();
            console.log("API Success:", result);

        } catch (error) {
            console.error("API Error:", error);
        }
    };


    // Filter and paginate the data
    const getPaginatedData = () => {
        console.log("assignTargetListing--------------", assignTargetListing);
        if (assignTargetListing.length != 0) {
            // setAssignedTargetArry(assignTargetListing);
        }


        // let filteredData = assignTargetListing.filter((survey, index) => {
        //     const shouldShow =
        //         (userType === "3" && survey.subDistrictName !== null) ||
        //         (userType !== "3" && (userType !== "2" || survey.districtName?.trim()));
        //     return shouldShow;
        // });

        // return filteredData.slice(indexOfFirstRecord, indexOfLastRecord);
    };

    const totalPages = Math.ceil(
        // assignTargetListing.filter((survey, index) => {
        //     const shouldShow =
        //         (userType === "3" && survey.subDistrictName !== null) ||
        //         (userType !== "3" && (userType !== "2" || survey.districtName?.trim()));
        //     return shouldShow;
        // }).length / recordsPerPage
    );

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    const goToFirstPage = () => {
        setCurrentPage(1);
    };

    const goToLastPage = () => {
        setCurrentPage(totalPages);
    };

    const goToPreviousPage = () => {
        setCurrentPage(prev => Math.max(prev - 1, 1));
    };

    const goToNextPage = () => {
        setCurrentPage(prev => Math.min(prev + 1, totalPages));
    };

    // Reset the row values (Sub District and Assign Target)

    const handleRowClear = () => {
        setSelectedValue('');
        setSelectedTypeData({
            revisedTargetByState: '',
            centralMission: ''
        });
        setInputValues(prev => ({
            ...prev,
            [0]: {
                ...prev[0],
                districtValue: "",
                assignDistrictTarget: ""
            }
        }));
    };

    useEffect(() => {
        surveysCountGroupWise();
        assignTargetData();
        getDistrict();
        handleSubDistrict();
        handleVillage();
        fetchSubSchemeType();
        if (sessionStorage.getItem("userRoleCodeModel") === "2") {
            setStateValue(sessionStorage.getItem("currentStateName") || "");
        }
    }, []);

    useEffect(() => {
        const joinedTargets = missionTargetSummary
            .filter(item => item.schemeSubTypeName && item.centralMission !== undefined)
            .map(item => `${item.schemeSubTypeName} - ${item.centralMission}`)
            .join(', ');

        setSummaryString(joinedTargets);
        if (missionTargetSummary && missionTargetSummary.length > 0) {
            setRowValues(
                missionTargetSummary.map(() => ({
                    subDistrictValue: '',
                    targetValue: ''
                }))
            );
        }
    }, [missionTargetSummary]);

    useEffect(() => {
        if (missionTargetSummary && missionTargetSummary.length > 0) {
            const initialInputs = {};
            missionTargetSummary.forEach((item, idx) => {
                initialInputs[idx] = {
                    revisedTargetByState: item.revisedTargetByState || ''
                };
            });
            setInputValues(initialInputs);
        }
    }, [missionTargetSummary]);

    // Reset current page when data changes 3333333333
    useEffect(() => {
        setCurrentPage(1);
    }, [assignTargetListing]);

    useEffect(() => {
        const stored = sessionStorage.getItem("finYear");
        if (!stored) {
            sessionStorage.setItem("finYear", finYear);
        }
    }, [finYear]);

    // Call when financial year is "2024-2025"
    useEffect(() => {
        const currentFinYear = sessionStorage.getItem("finYear") || "2024-2025";
        if (currentFinYear === "2024-2025") {
            fetchAssignTargetData();
        }
    }, [finYear]);

    const [inputValues, setInputValues] = useState({});
    const handleChange = (idx, value) => {
        setInputValues(prev => ({

            ...prev,
            [idx]: {
                ...prev[idx],
                revisedTargetByState: value
            }
        }));
    };

    async function surveysCountGroupWise() {
        const roleCode = sessionStorage.getItem("userRoleCodeModel");
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        const stateCode = sessionStorage.getItem("stateNameModel") || 0;
        const districtCode = sessionStorage.getItem("districtCodeModel") || 0;
        const subDistrictCode = sessionStorage.getItem("subDistrictNameModel") || 0;

        const parm = {
            schemeCode,
            stateCode: roleCode >= 2 ? stateCode : 0,
            districtCode: roleCode >= 3 ? districtCode : 0,
            subDistrictCode: roleCode >= 4 ? subDistrictCode : 0,
            userLevel: roleCode
        };

        try {
            const { data } = await axios.post(
                `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/SurveyCountGroupWise/SurveysCountGroupWise`,
                parm
            );
            setLatestSurveyCount(data.dataContent);
        } catch (error) {
            console.error("Error fetching  details:", error);
        }
    }

    const handleSubTypeSelect = (value) => {
        setSelectedValue(value);
    };

    const handleAdd = (e) => {
        e.preventDefault();
        if (rows.length < 2) {
            setRows(prevRows => {
                // Add the new row with a 'target' property
                return [...prevRows, { id: Date.now(), selected: '', custom: '', target: '' }];
            });
        } else {
            alert('Maximum 2 type allowed');
        }
    };

    const handleRemove = (id) => {
        setRows(rows.filter(row => row.id !== id));
    };

    const handleSelectChange = (id, value) => {
        setRows(rows.map(row =>
            row.id === id ? { ...row, selected: value.toString(), custom: '' } : row
        ));
    };

    const handleCustomChange = (id, value) => {
        setRows(rows.map(row =>
            row.id === id ? { ...row, custom: value } : row
        ));
    };

    const handleTargetChange = (id, value) => {
        setRows(rows.map(row =>
            row.id === id ? { ...row, target: value } : row
        ));
    };

    const getAvailableOptions = (currentId) => {
        // Gather all selected values from rows except the current row
        const rowSelectedValues = rows
            .filter(row => row.id !== currentId)
            .map(row => row.selected)
            .filter(val => val && val !== 'Other');

        let allSelected = [...rowSelectedValues];
        if (currentId === 'main') {
            // For main select, include all row selections (already done)
        } else {
            // For row selects, include main select's value if not 'Other' or 'NA'
            if (selectedValue && selectedValue !== 'Other' && selectedValue !== 'NA') {
                allSelected.push(selectedValue);
            }
        }
        return ddlSubTypeList.filter(option => !allSelected.includes(String(option.id)));
    };


    async function fetchSubSchemeType() {
        const schemeCode = sessionStorage.getItem("schemeCodeModel");
        const url = `${process.env.NODE_ENV === "development"
            ? process.env.REACT_APP_DEV_MODE
            : process.env.REACT_APP_PRO_MODE
            }/api/MissionTarget/MissionTarget/GetSchemaSubTypeList/${schemeCode}`;
        fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                setDDlSubTypeList(data.dataContent);

            })
            .catch(error => {
                console.error('Fetch error:', error);
            });
    }

    const createPayloads = () => {
        const payload = {
            finYear: sessionStorage.getItem("finYear"),
            orgTypeCode: sessionStorage.getItem("userRoleCodeModel"),
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            ...(sessionStorage.getItem("userRoleCodeModel") !== "1" && {
                StateCode: sessionStorage.getItem("stateNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "3" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "4" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "5" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
                villageCode: sessionStorage.getItem("villageModel"),
            }),
        };

        const payload_Report = {
            str_FinYear: sessionStorage.getItem("finYear"),
            userLevel: "1",
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            ...(sessionStorage.getItem("userRoleCodeModel") !== "1" && {
                StateCode: sessionStorage.getItem("stateNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "3" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "4" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "5" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
                villageCode: sessionStorage.getItem("villageModel"),
            }),
        };

        return {
            payload: payload,
            payload_Report: payload_Report
        };
    };

    // Optimized fetch function with reusable API call helper
    const fetchAssignTargetData = async () => {
        try {
            const { payload, payload_Report } = createPayloads();
            const baseURL = process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE;

            // Helper function for API calls
            const makeApiCall = async (endpoint, payload) => {
                const response = await fetch(`${baseURL}${endpoint}`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(payload),
                });
                return response.json();
            };

            // Try first API
            const result = await makeApiCall(
                "/api/MissionTarget/MissionTarget/getMissionTargetSummary1",
                payload
            );

            // Check if first API returned valid data
            if (result?.dataContent?.length > 0) {
                //  setAssignTargetListing([]);
                // return;
            }

            // Fallback to second API
            // console.log("First API returned empty/null, using fallback API");
            const result_Report = await makeApiCall(
                "/api/SurveyCountGroupWise/SurveysCountGroupWiseNew",
                payload_Report
            );


            if (result_Report?.dataContent?.length > 0) {
                // Transform fallback data to match first API structure
                const transformedData = result_Report.dataContent.map(item => ({
                    schemeName: item.schemeName || null,
                    stateName: item.stateName || null,
                    districtName: item.districtName || null,
                    subDistrictName: item.subDistrictName || null,
                    villageName: item.villageName || null,
                    // schemeSubTypeName: item.schemeSubTypeName || null,
                    schemeSubTypeName: item.targetType || null,
                    subTypeCode: null,
                    cropGroupName: null,
                    cropName: null,
                    cropCategoryCode: null,
                    cropNameCode: item.cropNameCode || null,
                    stateCode: item.stateCode || null,
                    schemeCode: item.schemeCode || null,
                    districtCode: item.districtCode || null,
                    subDistrictCode: item.subDistrictCode || null,
                    villageCode: item.villageCode || null,
                    centralMission: 0,
                    stateMission: 0,
                    districtMission: 0,
                    subDistrictMission: 0,
                    villageMission: 0,
                    pending: 0,
                    complete: item.totalSurveyArea || 0,
                    revisedTargetByState: null,
                    isRevisedByState: "N"
                }));
                console.log('transformedData:', transformedData);
                //setAssignTargetListing([]);
                setAssignTargetListing(transformedData);
                console.log('setAssignTargetListing fallback:', assignTargetListing);
                setAssignTargetReports(result_Report.dataContent);
                setAssignTargetListing(prevState => {
                    console.log("Previous state:", prevState.length, "records");
                    console.log("New state:", transformedData.length, "records");
                    return transformedData;
                });
            } else {
                setAssignTargetListing([]);
                setAssignTargetReports([]);
            }

        } catch (error) {
            console.error("Error fetching assign target data:", error);
            setAssignTargetListing([]);
            setAssignTargetReports([]);
        }
    };

    // Add this to see when setAssignTargetListing is called
    useEffect(() => {
        console.log("assignTargetListing updated:", assignTargetListing.length, "records");
    }, [assignTargetListing]);

    // Use functional update to avoid race conditions

    const assignTargetData = async () => {
        const payload = {
            finYear: sessionStorage.getItem("finYear") || getCurrentFinancialYear(),
            orgTypeCode: sessionStorage.getItem("userRoleCodeModel"),
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            ...(sessionStorage.getItem("userRoleCodeModel") !== "1" && {
                StateCode: sessionStorage.getItem("stateNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "3" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "4" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "5" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
                villageCode: sessionStorage.getItem("villageModel"),
            }),
        };
        const uL = sessionStorage.getItem("userRoleCodeModel");

        let userLevel = "";
        const userLevelMap = {
            "1": "1",
            "2": "1",
            "3": "2",
            "4": "3",
        };
        userLevel = userLevelMap[uL] || "";
        const payload_Report = {
            str_FinYear: sessionStorage.getItem("finYear") || getCurrentFinancialYear(),
            userLevel: userLevel,
            //strFinYear:"2025-2026",
            schemeCode: sessionStorage.getItem("schemeCodeModel"),
            ...(sessionStorage.getItem("userRoleCodeModel") !== "1" && {
                StateCode: sessionStorage.getItem("stateNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "3" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "4" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
            }),
            ...(sessionStorage.getItem("userRoleCodeModel") === "5" && {
                districtCode: sessionStorage.getItem("districtCodeModel"),
                subdistrictCode: sessionStorage.getItem("subDistrictNameModel"),
                villageCode: sessionStorage.getItem("villageModel"),
            }),
        };
        console.log('assignTargetData 111 payload for second api', payload);
        console.log('assignTargetData 111 payload_Report', payload_Report);
        //const response;
        let response;

        try {

            response = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/MissionTarget/MissionTarget/getMissionTargetSummary`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();
            const response_Report = await fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/SurveyCountGroupWise/SurveysCountGroupWiseNew`,
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload_Report),
                }
            );

            const result_Report = await response_Report.json();
            setAssignTargetReports(result_Report.dataContent);
            console.log('result.dataContent---1 ', result.dataContent);
            SetSelfAssignedTargetRecords(result.dataContent);
            console.log("selfAssignedTargetRecords--", selfAssignedTargetRecords);
            if (sessionStorage.getItem("userRoleCodeModel") === '3') {
                //alert();
                setAssignTargetListing(result.dataContent)
                console.log("assignTargetListing----------------", assignTargetListing);
            }
            console.log('result_Report.dataContent ', result_Report.dataContent);
            setAssignTargetListing(result.dataContent);
            if (sessionStorage.getItem("userRoleCodeModel") === "2") {
                setAssignTarget(result.dataContent?.[0]?.centralMission);
                setMissionTargetSummary(result.dataContent.filter(
                    item => Number(item.centralMission) !== 0
                ));

                // Group by schemeSubTypeName and count districtMission
                const groupedCounts = result.dataContent
                    .filter(item => Number(item.districtMission) > 0)
                    .reduce((groups, item) => {
                        const subType = item.schemeSubTypeName;
                        if (!groups[subType]) {
                            groups[subType] = {
                                schemeSubTypeName: subType,
                                count: 0,
                                totalDistrictMission: 0
                            };
                        }
                        groups[subType].count += 1;
                        groups[subType].totalDistrictMission += Number(item.districtMission);
                        return groups;
                    }, {});

                // Convert to array
                const groupedArray = Object.values(groupedCounts);
                setGroupedSchemeData(groupedArray);
                console.log('Grouped by schemeSubTypeName with counts:', groupedArray);


            } if (sessionStorage.getItem("userRoleCodeModel") === "3") {
                setMissionTargetSummary(result.dataContent.filter(
                    item => Number(item.districtMission) !== 0
                ));
                setAssignTargetListing(result.dataContent.filter(
                    item => Number(item.districtMission) === 0
                ));

                // Group by schemeSubTypeName and count districtMission
                const groupedCounts = result.dataContent
                    .filter(item => Number(item.subDistrictMission) > 0)
                    .reduce((groups, item) => {
                        const subType = item.schemeSubTypeName;
                        if (!groups[subType]) {
                            groups[subType] = {
                                schemeSubTypeName: subType,
                                count: 0,
                                totalsubDistrictMission: 0
                            };
                        }
                        groups[subType].count += 1;
                        groups[subType].totalsubDistrictMission += Number(item.subDistrictMission);
                        return groups;
                    }, {});

                // Convert to array
                const groupedArray = Object.values(groupedCounts);
                setGroupedSchemeData(groupedArray);
                console.log('Grouped by schemeSubTypeName with counts 111:', groupedArray);


            } if (sessionStorage.getItem("userRoleCodeModel") === "4") {
                setAssignSubDistrictTarget(result.dataContent?.[0]?.villageMission);
                setMissionTargetSummary(result.dataContent.filter(
                    item => Number(item.villageMission) === 0
                ));
                setAssignTargetListing(result.dataContent.filter(
                    item => Number(item.villageMission) !== 0
                ));
                // Group by schemeSubTypeName and count districtMission
                const groupedCounts = result.dataContent
                    .filter(item => Number(item.villageMission) > 0)
                    .reduce((groups, item) => {
                        const subType = item.schemeSubTypeName;
                        if (!groups[subType]) {
                            groups[subType] = {
                                schemeSubTypeName: subType,
                                count: 0,
                                totalvillageMission: 0
                            };
                        }
                        groups[subType].count += 1;
                        groups[subType].totalvillageMission += Number(item.villageMission);
                        return groups;
                    }, {});

                // Convert to array
                const groupedArray = Object.values(groupedCounts);
                setGroupedSchemeData(groupedArray);
                console.log('Grouped by schemeSubTypeName with counts villageMission:', groupedArray);

            }

            setRevisedByState(result.dataContent?.[0]?.isRevisedByState);
            setRevisedTargetByState(result.dataContent?.[0]?.revisedTargetByState);
            // Check conditions for showing modal
            if (
                sessionStorage.getItem("userRoleCodeModel") === "2" &&
                (result.dataContent?.[0]?.isRevisedByState === null || result.dataContent?.[0]?.isRevisedByState?.trim() === "" || (result.dataContent?.[0]?.isRevisedByState?.trim() === "Y" && result.dataContent?.[0]?.revisedTargetByState === null && result.dataContent?.[0]?.revisedTargetByState <= 0))
            ) {

                //setShowModal(true);
            }

        } catch (error) {
            console.error("API Error:", error);
            toast.error("Something went wrong!");
        }
    };


    function getStates() {
        const fetchStates = async () => {
            const result = await axios(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/states`
            );
            setStatesData(result.data.dataContent);
        };
        fetchStates();
    }


    function getDistrict() {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");

        var raw = JSON.stringify({
            stateCode: Number(sessionStorage.getItem("stateNameModel")),
        });

        var requestOptions = {
            method: "POST",
            headers: myHeaders,
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/district`,
            requestOptions
        )
            .then((response) => response.text())
            .then((result) => setDistrictData(JSON.parse(result).dataContent))
            .catch((error) => console.log("error", error));

    }
    const handleVillage = () => {
        console.log('handleVillage called');

        var stateCode = sessionStorage.getItem("stateNameModel");
        var districtCode = sessionStorage.getItem("districtCodeModel");
        var subDistrictCode = sessionStorage.getItem("subDistrictNameModel");
        if ((stateCode !== null && stateCode !== "0") && (districtCode !== null && districtCode !== "0") && (subDistrictCode !== null && subDistrictCode !== "0")) {

            var raw = JSON.stringify({
                stateCode,
                districtCode,
                subDistrictCode

            });
            console.log('raw: ', raw);
            var myHeaders = new Headers();
            myHeaders.append("Content-Type", "application/json");
            var requestOptions = {
                method: "POST",
                headers: myHeaders,
                redirect: "follow",
                body: raw
            };
            fetch(
                `${process.env.NODE_ENV === "development"
                    ? process.env.REACT_APP_DEV_MODE
                    : process.env.REACT_APP_PRO_MODE
                }/api/village`,
                requestOptions
            )

                .then((response) => response.text())
                .then((result) => {
                    let localFormDataVillage = JSON.parse(result).dataContent;
                    console.log('localFormDataVillage: ', localFormDataVillage);
                    let myArrayVillage = [];
                    localFormDataVillage.map((item, key) => {
                        myArrayVillage.push({ label: item.villageName, value: item.villageCode, subDistrictCode: item.subDistrictCode })
                    })
                    setOptionVillage(myArrayVillage)
                })
                .catch((error) => console.log("error", error));
        }
        console.log('optionVillage: ', optionVillage);
    }
    const handleSubDistrict = (value) => {
        const districtCode = sessionStorage.getItem("districtCodeModel")

        if (districtCode === null) {
            setDistrictValue(districtCode);
        } else {

            setDistrictValue(value);
        }

        if (districtCode === "NA") return;

        const raw = JSON.stringify({
            districtcode: districtCode,
        });

        const requestOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: raw,
            redirect: "follow",
        };

        fetch(
            `${process.env.NODE_ENV === "development"
                ? process.env.REACT_APP_DEV_MODE
                : process.env.REACT_APP_PRO_MODE
            }/api/subdistrict`,
            requestOptions
        )
            .then((response) => response.json())
            .then((result) => setSubDistrictData(result.dataContent))
            .catch((error) => console.log("Error fetching sub-districts:", error));
    };
    const handleSubmit = async (status) => {
        // Validation for the main row
        if (status === 0) {
            // Validate state selection
            if (stateValue === "NA" || !stateValue) {
                alert("Please select a State before assigning the target.");
                return; // Stop further processing
            }
            if (!assignTarget || isNaN(assignTarget) || Number(assignTarget) <= 0) {
                //toast.error("Please enter a valid Assign Target for the first row");
                alert("Please enter a valid Assign Target for the first row");
                return;
            }
            if (selectedValue === "NA" || !selectedValue) {
                alert("Please select a Type before assigning the target.");
                return; // Stop further processing
            }
            if (selectedValue === 'Other' && (!txtlType || txtlType.trim() === "")) {
                alert(`Please enter a value for 'Enter Type' at first row`);
                return;
            }

        }

        let isValid = true;

        if (!isValid) return;

        if (status === 4) {

            // Get the currently selected type data
            const selectedItem = missionTargetSummary.find(
                item => item.schemeSubTypeName === selectedValue
            );

            if (!selectedItem) {
                alert("Please select a Type first.");
                return;
            }

            const assignTargetValue = rowValues[0]?.targetValue;

            // 1. Validate the Sub District Dropdown
            const subDistrictValue = rowValues[0]?.subDistrictValue;
            if (!subDistrictValue || subDistrictValue === "") {
                alert("Please select a Sub District.");
                return; // Stop the entire function
            }

            // 2. Validate the Assign Target Textbox (must be a positive number)
            if (!assignTargetValue || isNaN(assignTargetValue) || Number(assignTargetValue) <= 0) {
                alert("Please enter a valid number for Assign Target.");
                return; // Stop the entire function
            }

            // 3. Validate against total Assign Target for this schemeSubTypeName
            const currentAssignTarget = Number(assignTargetValue);

            // Get existing Assign Target values for this schemeSubTypeName from groupedSchemeData
            const existingAssignTargets = groupedSchemeData
                .filter(group => group.schemeSubTypeName === selectedValue);
            //console.log('existingAssignTargets-totalDistrictMission: ', existingAssignTargets[0]?.totalDistrictMission);

            const PreviousSubSchemCount = isNaN(existingAssignTargets[0]?.totalsubDistrictMission)
                ? 0
                : existingAssignTargets[0].totalsubDistrictMission;

            // Calculate total Assign Target for this schemeSubTypeName
            const totalAssignTargetForScheme = PreviousSubSchemCount + currentAssignTarget;
            // 4. Validation logic based on Assign By State
            // Get the original data from missionTargetSummary to get Assign By State
            const originalData = missionTargetSummary.find(item => item.schemeSubTypeName === selectedValue);
            const assignByState = Number(originalData?.districtMission || 0); // This is the Assign By State value

            // Validate against Assign By State
            if (totalAssignTargetForScheme > assignByState) {
                alert(`Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Assign By State (${assignByState}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`);
                return; // Stop the entire function
            }


            // Create payload based on selected type
            const payload = [{
                finYear: sessionStorage.getItem("finYear"),
                schemeCode: selectedItem.schemeCode,
                stateCode: selectedItem.stateCode,
                districtCode: selectedItem.districtCode,
                subDistrictCode: rowValues[0]?.subDistrictValue || '',
                missionTarget: rowValues[0]?.targetValue || '',
                userTypeCode: sessionStorage.getItem("userRoleCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                subTypeCode: selectedItem.subTypeCode
            }];

            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData();
                    toast.success(result.message);

                    // Reset form inputs
                    setRowValues(prev =>
                        prev.map((row, i) => ({
                            ...row,
                            subDistrictValue: "",
                            targetValue: ""
                        }))
                    );

                    // Reset SubType to "Choose" and clear Assign By State
                    setSelectedValue('');
                    setSelectedTypeData({
                        districtName: '',
                        districtMission: ''
                    });

                } else {
                    toast.error("Failed to assign target: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
        else if (status === 3) {
            // Get the currently selected type data
            const selectedItem = missionTargetSummary.find(
                item => item.schemeSubTypeName === selectedValue
            );

            if (!selectedItem) {
                alert("Please select a Type first.");
                return;
            }

            const assignTargetValue = inputValues[0]?.assignDistrictTarget;

            // 1. Validate the District Dropdown
            const districtValue = inputValues[0]?.districtValue;
            if (!districtValue || districtValue === "NA") {
                alert("Please select a District.");
                return; // Stop the entire function
            }

            // 2. Validate the Assign Target Textbox (must be a positive number)
            if (!assignTargetValue || isNaN(assignTargetValue) || Number(assignTargetValue) <= 0) {
                alert("Please enter a valid number for Assign Target.");
                return; // Stop the entire function
            }

            // 3. Validate that Assign Target is not greater than the available target
            const currentAssignTarget = Number(assignTargetValue);

            // Get existing Assign Target values for this schemeSubTypeName from groupedSchemeData
            const existingAssignTargets = groupedSchemeData
                .filter(group => group.schemeSubTypeName === selectedValue);
            //const PreviousSubSchemCount = existingAssignTargets[0]?.totalDistrictMission;
            const PreviousSubSchemCount = isNaN(existingAssignTargets[0]?.totalDistrictMission)
                ? 0
                : existingAssignTargets[0].totalDistrictMission;
            // Calculate total Assign Target for this schemeSubTypeName
            const totalAssignTargetForScheme = PreviousSubSchemCount + currentAssignTarget;
            // 4. CORRECTED Validation logic based on Target Revised By State
            // Get the original data from missionTargetSummary to get correct Target Revised By State
            const originalData = missionTargetSummary.find(item => item.schemeSubTypeName === selectedValue);
            //console.log('originalData: ', originalData);
            const targetRevisedByState = Number(originalData?.revisedTargetByState || 0); // This is the actual Target Revised By State
            const assignByCentral = Number(originalData?.centralMission || 0); // This is the actual Assign By Central

            let availableTarget;
            let alertMessage;

            if (targetRevisedByState === 0) {
                // If Target Revised By State is 0, validate against Assign By Central
                availableTarget = assignByCentral;
                alertMessage = `Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Assign By Central (${availableTarget}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`;
            } else {
                // If Target Revised By State > 0, validate against Target Revised By State
                availableTarget = targetRevisedByState;
                alertMessage = `Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Target Revised By State (${availableTarget}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`;
            }

            if (totalAssignTargetForScheme > availableTarget) {
                alert(alertMessage);
                return; // Stop the entire function
            }

            // Create payload based on selected type
            const payload = [{
                finYear: sessionStorage.getItem("finYear"),
                schemeCode: sessionStorage.getItem("schemeCodeModel"),
                stateCode: selectedItem.stateCode,
                districtCode: inputValues[0]?.districtValue || "",
                userTypeCode: sessionStorage.getItem("userRoleCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                missionTarget: inputValues[0]?.assignDistrictTarget || "",
                subTypeCode: selectedItem.subTypeCode
            }];

            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData();
                    toast.success(result.message);
                    setAssignTarget("");
                    setSelectedValue('');
                    setRows([]);
                    setShowModal(false);
                    setInputValues(prev => ({
                        ...prev,
                        [0]: {
                            ...prev[0],
                            districtValue: "",
                            assignDistrictTarget: ""
                        }
                    }));
                    // Reset Type to "Choose" and clear Assign By Central
                    setSelectedTypeData({
                        revisedTargetByState: '',
                        centralMission: ''
                    });
                } else {
                    toast.error("Failed to assign target: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
        else if (status === 5) {
            // Get the currently selected type data
            const selectedItem = missionTargetSummary.find(
                item => item.schemeSubTypeName === selectedValue
            );

            if (!selectedItem) {
                alert("Please select a Type first.");
                return;
            }

            const assignTargetValue = rowValues[0]?.targetValue;

            // 1. Validate the Village Dropdown
            const villageValue = rowValues[0]?.villageValue;
            if (!villageValue || villageValue === "") {
                alert("Please select a Village.");
                return; // Stop the entire function
            }

            // 2. Validate the Assign Target Textbox (must be a positive number)
            if (!assignTargetValue || isNaN(assignTargetValue) || Number(assignTargetValue) <= 0) {
                alert("Please enter a valid number for Assign Target.");
                return; // Stop the entire function
            }

            //// 3. Validate that Assign Target is not greater than the available target
            //const assignTarget = Number(assignTargetValue);
            //const subDistrictMission = Number(selectedItem.subDistrictMission);

            //if (assignTarget > subDistrictMission) {
            //    alert(`The Assign Target (${assignTarget}) cannot be greater than the Assign By Sub District (${subDistrictMission}).`);
            //    return; // Stop the entire function
            //}

            // 3. Validate against total Assign Target for this schemeSubTypeName
            const currentAssignTarget = Number(assignTargetValue);

            // Get existing Assign Target values for this schemeSubTypeName from groupedSchemeData
            const existingAssignTargets = groupedSchemeData
                .filter(group => group.schemeSubTypeName === selectedValue);
            // const PreviousSubSchemCount = existingAssignTargets[0]?.totalvillageMission;

            const PreviousSubSchemCount = isNaN(existingAssignTargets[0]?.totalvillageMission)
                ? 0
                : existingAssignTargets[0].totalvillageMission;
            // Calculate total Assign Target for this schemeSubTypeName
            const totalAssignTargetForScheme = PreviousSubSchemCount + currentAssignTarget;
            console.log('totalAssignTargetForScheme: ', totalAssignTargetForScheme);

            // 4. Validation logic based on Assign By Sub District
            // Get the original data from missionTargetSummary to get Assign By Sub District
            const originalData = missionTargetSummary.find(item => item.schemeSubTypeName === selectedValue);
            const assignBySubDistrict = Number(originalData?.subDistrictMission || 0); // This is the Assign By Sub District value

            // Validate against Assign By Sub District
            if (totalAssignTargetForScheme > assignBySubDistrict) {
                alert(`Total Assign Target for ${selectedValue} (${totalAssignTargetForScheme}) cannot exceed the Assign By Sub District (${assignBySubDistrict}). Current input: ${currentAssignTarget}, Existing total: ${totalAssignTargetForScheme - currentAssignTarget}`);
                return; // Stop the entire function
            }

            // Create payload based on selected type
            const payload = [{
                finYear: sessionStorage.getItem("finYear"),
                schemeCode: selectedItem.schemeCode,
                stateCode: selectedItem.stateCode,
                districtCode: selectedItem.districtCode,
                subDistrictCode: selectedItem.subDistrictCode,
                villageCode: rowValues[0]?.villageValue || '',
                missionTarget: rowValues[0]?.targetValue || '',
                userTypeCode: sessionStorage.getItem("userRoleCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                subTypeCode: selectedItem.subTypeCode
            }];
            //console.log('payload at v: ', payload);
            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payload),
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData();
                    toast.success(result.message);

                    // Reset form inputs
                    setRowValues(prev =>
                        prev.map((row, i) => ({
                            ...row,
                            villageValue: "",
                            targetValue: ""
                        }))
                    );

                    // Reset SubType to "Choose" and clear Assign By Sub District
                    setSelectedValue('');
                    setSelectedTypeData({
                        revisedTargetByState: '',
                        centralMission: ''
                    });
                } else {
                    toast.error("Failed to assign target: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
        else {
            // --- Create an array for all targets ---
            const targets = [];
            const isRevisedChar = isStateRevised ? 'Y' : 'N';

            // 1. Add the main/fixed row
            const mainRowTarget = {
                finYear: sessionStorage.getItem("finYear"),
                schemeCode: sessionStorage.getItem("schemeCodeModel"),
                stateCode: sessionStorage.getItem("userRoleCodeModel") === "1" ? stateValue : sessionStorage.getItem("stateNameModel"),
                districtCode: districtValue === 'null' ? '0' : districtValue,
                subDistrictCode: subDistrictValues || 0,
                villageCode: villageCode || 0,
                userTypeCode: sessionStorage.getItem("userRoleCodeModel"),
                createdBy: sessionStorage.getItem("userCodeModel"),
                missionTarget: assignTarget,
                subTypeName: selectedValue === 'Other' ? txtlType : null,
                subTypeCode: selectedValue === 'Other' ? -1 : selectedValue,
                IsRevisedByState: isRevisedChar,
            };
            targets.push(mainRowTarget);


            for (const [index, row] of rows.entries()) {
                // Validation for dynamic rows
                if (!row.target || isNaN(row.target) || Number(row.target) <= 0) {
                    alert(`Please enter a valid Assign Target at Row ${index + 2}.`);
                    return;
                }

                if (!row.selected) {
                    //toast.error(`Row ${index + 1}: Please select a type for all added rows.`);
                    alert(`Please select a Type at Row ${index + 2}.`);
                    return;
                }

                if (row.selected === 'Other' && !row.custom) {
                    alert(`Please enter a value for 'Enter Type' at Row ${index + 2}.`);
                    return;
                }

                const dynamicRowTarget = {
                    ...mainRowTarget, // Copy common properties
                    missionTarget: row.target, // Use the row's specific target
                    subTypeName: row.selected === 'Other' ? row.custom : null,
                    subTypeCode: row.selected === 'Other' ? -1 : row.selected,
                    IsRevisedByState: isRevisedChar,
                };
                targets.push(dynamicRowTarget);
            }


            // If status === 2, use missionTargetSummary with revisedTarget values as payload
            let payloadToSend = targets;
            if (status === 2 && Array.isArray(missionTargetSummary) && missionTargetSummary.length > 0) {
                payloadToSend = missionTargetSummary.map((item, idx) => ({
                    ...item,
                    finYear: sessionStorage.getItem("finYear"),
                    userTypeCode: sessionStorage.getItem("userRoleCodeModel"),
                    createdBy: sessionStorage.getItem("userCodeModel"),
                    subTypeCode: item.subTypeCode,
                    IsRevisedByState: "Y",
                    RevisedTargetByState: inputValues[idx]?.revisedTargetByState || '',
                    // RevisedTargetByState: inputValues[idx] || '',
                    missionTarget: item.centralMission // Use centralMission for each item
                }));
                console.log('POST payload (missionTargetSummary with revised fields):', payloadToSend);
            } else {
                console.log('POST payload (default targets):', payloadToSend);
            }

            try {
                const response = await fetch(
                    `${process.env.NODE_ENV === "development" ? process.env.REACT_APP_DEV_MODE : process.env.REACT_APP_PRO_MODE}/api/MissionTarget/MissionTarget/AddMissionTargetNew`,// Manvendra
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(payloadToSend), // Send the array
                    }
                );

                const result = await response.json();
                if (response.ok) {
                    assignTargetData(); // Refresh
                    toast.success(result.message);
                    // Clear fields
                    setAssignTarget("");
                    setStateValue("NA");
                    setSelectedValue('');
                    setRows([]);
                    setShowModal(false);
                } else {
                    toast.error("Failed to assign target else: " + result.message);
                }
            } catch (error) {
                console.error("API Error:", error);
                toast.error("Something went wrong!");
            }
        }
    };

    const handleClear = () => {
        //console.log('handleClear');
        setAssignTarget("");
        setSelectedValue("");
        setTxtlType(""); // Also clear the 'Other' text field
        setStateValue("NA");
        // Remove all dynamically added rows
        setRows([]);
    };


    return (

        <>
            <ToastContainer autoClose={7000} />

            <AdminHeaderNew />
            {sessionStorage.getItem("schemeCodeModel") === "16" 
  ? <AdminSideBarMnt />
  : <AdminSideBarNew />
}
            {/* <AdminSideBarNew /> */}

            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Assign Target PDMC</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Admin</li>
                            <li className="breadcrumb-item active">Assign Target</li>
                        </ol>
                    </nav>
                </div>
                <div>
                    <div className="row mb-4">
                        <div className="col-md-2 finacildd_label">
                            <div className="form-group text-white">
                                <label htmlFor="finYear" className="form-label text-white">Financial Year</label>
                                <select
                                    id="finYear"
                                    name="finYear"
                                    className="form-select"
                                    value={finYear}
                                    onChange={handleFinYearChange}
                                >
                                    <option value="2025-2026">2025-2026</option>
                                    <option value="2024-2025">2024-2025</option>
                                </select>
                            </div>
                        </div>
                    </div>
                </div>

                {/*Rashmi*/}
                <section className="section dashboard asigntarget">
                    <div className="row surveydetailsBg">
                        {userType !== "1" && userType !== "4" && userType !== "2" && userType !== "3" && userType !== "5" && (
                            <>
                                <div className="col-md-3">
                                    <label htmlFor="finYear" className="form-label assignlbl">Financial Year</label>
                                    <input
                                        type="text"
                                        id="finYear"
                                        className="form-control"
                                        name="finYear"
                                        value={finYear}
                                        readOnly
                                    />
                                </div>

                            </>
                        )}
                        {userType !== "1" && userType !== "4" && userType !== "2" && userType !== "3" && userType !== "5" && (

                            <div className="col-md-2">
                                <label htmlFor="schemeName" className="form-label assignlbl">State</label>
                                <input
                                    type="text"
                                    id="schemeName"
                                    className="form-control"
                                    name="schemeName"
                                    value={currentStateName}
                                    readOnly
                                />
                            </div>
                        )}

                        {userType === "4" && (
                            <>
                                <div className="row mb-3" key="header-row">
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Financial Year</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Type</label>
                                    </div>

                                </div>
                                {/* Single Data Row */}
                                <div className="row mb-3" key="single-data-row">
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={finYear}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            value={selectedValue || ''}
                                            onChange={(e) => {
                                                setSelectedValue(e.target.value);

                                                if (e.target.value === '') {
                                                    // If "Choose" is selected, reset all values to empty
                                                    setSelectedTypeData({
                                                        revisedTargetByState: '',
                                                        centralMission: ''
                                                    });
                                                } else {
                                                    // Find the selected item from missionTargetSummary
                                                    const selectedItem = missionTargetSummary.find(
                                                        item => item.schemeSubTypeName === e.target.value
                                                    );
                                                    if (selectedItem) {
                                                        // Update the values based on selected type
                                                        setSelectedTypeData({
                                                            revisedTargetByState: selectedItem.revisedTargetByState || '',
                                                            centralMission: selectedItem.subDistrictMission || '' // Use subDistrictMission for sub-district level
                                                        });
                                                    }
                                                }
                                                handleVillage();
                                                // Reset village select and assign target
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        villageValue: "",
                                                        targetValue: ""
                                                    }))
                                                );
                                            }}
                                        >
                                            <option value="">Choose...</option>
                                            {missionTargetSummary.map((item, idx) => (
                                                <option key={idx} value={item.schemeSubTypeName}>
                                                    {item.schemeSubTypeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                </div>
                            </>
                        )}
                        {userType === "3" && (
                            <>
                                <div className="row mb-3" key="header-row">
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Financial Year</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Type</label>
                                    </div>

                                </div>
                                {/* Single Data Row */}
                                <div className="row mb-3" key="single-data-row">
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={finYear}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            value={selectedValue || ''}
                                            onChange={(e) => {
                                                setSelectedValue(e.target.value);

                                                if (e.target.value === '') {
                                                    // If "Choose" is selected, reset all values to empty
                                                    setSelectedTypeData({
                                                        districtName: '',
                                                        districtMission: ''
                                                    });
                                                } else {
                                                    // Find the selected item from missionTargetSummary
                                                    const selectedItem = missionTargetSummary.find(
                                                        item => item.schemeSubTypeName === e.target.value
                                                    );
                                                    if (selectedItem) {
                                                        // Update the values based on selected type
                                                        setSelectedTypeData({
                                                            districtName: selectedItem.districtName || '',
                                                            districtMission: selectedItem.districtMission || ''
                                                        });
                                                    }
                                                }

                                                // Reset sub district select and assign target
                                                setRowValues(prev =>
                                                    prev.map((row, i) => ({
                                                        ...row,
                                                        subDistrictValue: "",
                                                        targetValue: ""
                                                    }))
                                                );
                                            }}
                                        >
                                            <option value="">Choose...</option>
                                            {missionTargetSummary.map((item, idx) => (
                                                <option key={idx} value={item.schemeSubTypeName}>
                                                    {item.schemeSubTypeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </>
                        )}
                        {/*Rashmi*/}
                        {/*{sessionStorage.getItem("userRoleCodeModel") === "111111" &&*/}
                        {/*<>*/}
                        {/*<div className="col-md-3">*/}
                        {/*            <label htmlFor="finYear" className="form-label assignlbl">Financial Year</label>*/}
                        {/*            <input*/}
                        {/*                type="text"*/}
                        {/*                id="finYear"*/}
                        {/*                className="form-control"*/}
                        {/*                name="finYear"*/}
                        {/*                value={finYear}*/}
                        {/*                readOnly*/}
                        {/*            />*/}
                        {/*        </div>*/}
                        {/*    <div className="col-md-3">*/}
                        {/*        <label htmlFor="state" className="form-label assignlbl">State</label>*/}
                        {/*        <select*/}
                        {/*            id="state"*/}
                        {/*            className="form-select"*/}
                        {/*            value={stateValue}*/}
                        {/*            onChange={(e) => setStateValue(e.target.value)}*/}
                        {/*            onClick={getStates} // consider moving to useEffect instead*/}
                        {/*        >*/}
                        {/*            <option value="NA">Choose...</option>*/}
                        {/*            {statesData.map((item, idx) => (*/}
                        {/*                <option key={idx} value={item.stateCode}>*/}
                        {/*                    {item.stateName}*/}
                        {/*                </option>*/}
                        {/*            ))}*/}
                        {/*        </select>*/}
                        {/*    </div>*/}
                        {/*</>*/}
                        {/*}*/}

                        {sessionStorage.getItem("userRoleCodeModel") === "2" && (
                            <>
                                {/* Header Row: Only labels */}
                                <div className="row mb-3" key="header-row">
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Financial Year</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Type</label>
                                    </div>
                                    {/* <div className="col-md-2">
                                        <label className="form-label assignlbl">Target Revised By State</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Assign By Central</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">District</label>
                                    </div>
                                    <div className="col-md-2">
                                        <label className="form-label assignlbl">Assign Target</label>
                                    </div> */}
                                </div>
                                {/* Single Data Row */}
                                <div className="row mb-3" key="single-data-row">
                                    <div className="col-md-2">
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={finYear}
                                            readOnly
                                        />
                                    </div>
                                    <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            value={selectedValue || ''}
                                            onChange={(e) => {
                                                setSelectedValue(e.target.value);
                                                if (e.target.value === '') {
                                                    // If "Choose" is selected, reset all values to empty
                                                    setSelectedTypeData({
                                                        revisedTargetByState: '',
                                                        centralMission: ''
                                                    });
                                                } else {
                                                    // Find the selected item from missionTargetSummary
                                                    const selectedItem = missionTargetSummary.find(
                                                        item => item.schemeSubTypeName === e.target.value
                                                    );
                                                    if (selectedItem) {
                                                        // Update the values based on selected type
                                                        setSelectedTypeData({
                                                            revisedTargetByState: selectedItem.revisedTargetByState || '',
                                                            centralMission: selectedItem.centralMission || ''
                                                        });
                                                    }
                                                }
                                                // Reset district select and assign target
                                                setInputValues(prev => ({
                                                    ...prev,
                                                    [0]: {
                                                        ...prev[0],
                                                        districtValue: "",
                                                        assignDistrictTarget: ""
                                                    }
                                                }));
                                            }}
                                        >
                                            <option value="">Choose...</option>
                                            {missionTargetSummary.map((item, idx) => (
                                                <option key={idx} value={item.schemeSubTypeName}>
                                                    {item.schemeSubTypeName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    {/* <div className="col-md-2">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={selectedTypeData.revisedTargetByState || 0}
                                            readOnly
                                        />
                                    </div> */}
                                    {/* <div className="col-md-2">
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={selectedTypeData.centralMission || 0}
                                            readOnly
                                        />
                                    </div> */}
                                    {/* <div className="col-md-2">
                                        <select
                                            className="form-select"
                                            disabled={!selectedValue}
                                            onChange={e =>
                                                setInputValues(prev => ({
                                                    ...prev,
                                                    [0]: {
                                                        ...prev[0],
                                                        districtValue: e.target.value
                                                    }
                                                }))
                                            }
                                            value={inputValues[0]?.districtValue || ""}
                                        >
                                            <option defaultValue value="NA">
                                                Choose...
                                            </option>
                                            {districtData && districtData.map((dItem, dIdx) => (
                                                <option key={dIdx} value={dItem.districtCode}>
                                                    {dItem.districtName}
                                                </option>
                                            ))}
                                        </select>
                                    </div> */}
                                    {/* <div className="col-md-2">
                                        <input
                                            type="number"
                                            className="form-control"
                                            disabled={!selectedValue}
                                            value={inputValues[0]?.assignDistrictTarget || ""}
                                            placeholder="Enter target"
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || Number(val) >= 0) {
                                                    setInputValues((prev) => ({
                                                        ...prev,
                                                        [0]: {
                                                            ...prev[0],
                                                            assignDistrictTarget: val
                                                        }
                                                    }));
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "+" || e.key === "-" || e.key.toLowerCase() === "e") {
                                                    e.preventDefault();
                                                }
                                            }}
                                        />

                                    </div> */}

                                </div>
                            </>
                        )}

                        {/*12-08-2025*/}
                        {sessionStorage.getItem("userRoleCodeModel") === "1" && (
                            <>
                                <div className="row">
                                    <div className="col-md-4">
                                        <label htmlFor="finYear" className="form-label assignlbl">Financial Year</label>
                                        <input
                                            type="text"
                                            id="finYearStatic"
                                            className="form-control"
                                            name="finYear"
                                            value={finYear}
                                            readOnly
                                        />

                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="state" className="form-label assignlbl">State</label>
                                        <select
                                            id="state"
                                            className="form-select"
                                            value={stateValue}
                                            onChange={(e) => setStateValue(e.target.value)}
                                            onClick={getStates} // consider moving to useEffect instead
                                        >
                                            <option value="NA">Choose...</option>
                                            {statesData.map((item, idx) => (
                                                <option key={idx} value={item.stateCode}>
                                                    {item.stateName}
                                                </option>
                                            ))}
                                        </select>
                                    </div>


                                </div>

                                <div className="row mt-3" style={{ borderBottom: '1px dashed  #ccc' }}></div>


                                <div className="row mt-3">
                                    <div className="col-md-4">
                                        <label htmlFor="ddlType" className="form-label assignlbl">
                                            Type
                                        </label>
                                        <select
                                            id="ddlType"
                                            className="form-select"
                                            onChange={(e) => handleSubTypeSelect(e.target.value)}
                                            value={selectedValue}>
                                            <option defaultValue value="NA">
                                                Choose...
                                            </option>
                                            {getAvailableOptions('main').map(option => (
                                                <option key={option.id} value={option.id.toString()}>
                                                    {option.schemeSubTypeName}
                                                </option>
                                            ))}
                                            {/*<option value="Other">Other</option>*/}
                                        </select>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="assignTarget" className="form-label assignlbl">
                                            Assign Target
                                        </label>
                                        <input
                                            type="number"
                                            id="assignTarget"
                                            className="form-control"
                                            name="assignTarget"
                                            placeholder={targetPlaceholder}
                                            value={assignTarget}
                                            onChange={(e) => {
                                                const val = e.target.value;
                                                if (val === "" || Number(val) >= 0) {
                                                    setAssignTarget(val);
                                                }
                                            }}
                                            onKeyDown={(e) => {
                                                if (e.key === "-" || e.key.toLowerCase() === "e" || e.key === "+") {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onFocus={() => setTargetPlaceholder("")}
                                            onBlur={() => {
                                                if (!assignTarget) setTargetPlaceholder("000000"); // fixed variable name
                                            }}
                                        />

                                    </div>
                                    {selectedValue === 'Other' && (
                                        <div className="col-md-2">
                                            <label htmlFor="txtType" className="form-label assignlbl">
                                                Enter Type
                                            </label>
                                            <input
                                                type="text"
                                                id="txtType"
                                                className="form-control"
                                                name="txtType"
                                                placeholder="Enter custom option"
                                                value={txtlType}
                                                onChange={(e) => setTxtlType(e.target.value)}
                                            />
                                        </div>
                                    )}
                                    <div className="col-md-1">
                                        <label className="form-label" style={{ color: 'transparent' }}>Add</label>
                                        <a href="#" onClick={handleAdd} className="btn btn-primary w-100 mt-1"><i className="bi bi-plus"></i></a>
                                    </div>
                                </div>

                            </>
                        )}
                        {rows.map((row, index) => (
                            <div className="row mt-2 align-items-end" key={row.id} >
                                <div className="col-md-4">
                                    <label htmlFor={`ddlType-${row.id}`} className="form-label assignlbl">
                                        Type
                                    </label>
                                    <select
                                        id={`ddlType-${row.id}`}
                                        className="form-control"
                                        value={row.selected}
                                        onChange={(e) => handleSelectChange(row.id, e.target.value)}
                                    >
                                        <option value="">Choose...</option>
                                        {getAvailableOptions(row.id).map(option => (
                                            <option key={option.id} value={option.id.toString()}>
                                                {option.schemeSubTypeName}
                                            </option>
                                        ))}
                                        {/*  <option value="Other">Other</option>*/}
                                    </select>
                                </div>
                                <div className="col-md-4">
                                    <label htmlFor={`assignTarget-${row.id}`} className="form-label assignlbl">
                                        Assign Target
                                    </label>
                                    <input
                                        type="number"
                                        id={`assignTarget-${row.id}`}
                                        className="form-control"
                                        name="assignTarget"
                                        placeholder="000000"
                                        value={row.target}
                                        onChange={(e) => {
                                            const val = e.target.value;
                                            if (val === "" || Number(val) >= 0) {
                                                handleTargetChange(row.id, val);
                                            }
                                        }}
                                        onKeyDown={(e) => {
                                            if (["-", "e", "+"].includes(e.key.toLowerCase())) {
                                                e.preventDefault();
                                            }
                                        }}
                                    />
                                </div>

                                {row.selected === 'Other' && (
                                    <div className="col-md-3">
                                        <label htmlFor={`txtType-${row.id}`} className="form-label assignlbl">
                                            Enter Type
                                        </label>
                                        <input
                                            id={`txtType-${row.id}`}
                                            className="form-control"
                                            type="text"
                                            value={row.custom}
                                            placeholder="Enter custom option"
                                            onChange={(e) => handleCustomChange(row.id, e.target.value)}
                                        />
                                    </div>
                                )}
                                <div className="col-md-1">
                                    <label className="form-label" style={{ color: 'transparent' }}>Remove</label>
                                    <a href="#" onClick={e => { e.preventDefault(); handleRemove(row.id); }} className="btn btn-danger w-100"><i className="bi bi-dash"></i></a>
                                </div>
                            </div>
                        ))}

                        {userType === "2" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-3">
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" >

                                    Submit
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleRowClear} >
                                    Clear
                                </button>
                            </div>
                        )}

                        {userType === "4" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-3">
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(5)} >

                                    Submit
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleRowClearVillage} >
                                    Clear
                                </button>
                            </div>
                        )}

                        {userType === "3" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-3">
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(4)} >
                                    Submit
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleRowClearSubDistrict} >
                                    Clear
                                </button>
                            </div>
                        )}

                        {userType != "4" && userType != "2" && userType != "3" && userType != "5" && (
                            <div className="col-md-12 d-flex justify-content-md-center mt-5">
                                {/* START: ADD THIS SECTION FOR THE TOGGLE SWITCH */}
                                <div className="col-md-3 d-flex align-items-end">

                                    {/* This new container will arrange its children (the label and the switch) in a row */}
                                    <div className="form-group-horizontal-toggle">

                                        {/* The Label */}
                                        <label htmlFor="stateReviseToggle" className="form-label assignlbl">
                                            State Revise Target
                                        </label>


                                        <label className="toggle-switch">
                                            <input
                                                type="checkbox"
                                                id="stateReviseToggle"
                                                checked={isStateRevised}
                                                onChange={() => setIsStateRevised(!isStateRevised)}
                                            />
                                            <span className="slider"></span>
                                        </label>
                                    </div>
                                </div>
                                {/* END: ADD THIS SECTION FOR THE TOGGLE SWITCH */}
                                <button type="button" className="btn btn-primary farmrbtn me-md-2" onClick={() => handleSubmit(0)} >

                                    Assign Target
                                </button>
                                <button type="button" className="btn btn-success me-md-2" onClick={handleClear} >
                                    Clear
                                </button>
                            </div>

                        )}

                        {selfAssignedTargetRecords.length > 0 && (
                            <div className="col-md-12">
                                <div className="bigbox1 mt-4">
                                    <div className="card">
                                        <div className="">
                                            <table className="table table-striped">
                                                <thead className="table-primary">
                                                    <tr>
                                                        <th>Sr. No</th>
                                                        <th>Type</th>
                                                        <th>Physical Target </th>
                                                        <th>Physical Achievement </th>
                                                        <th>Verified by Krishi MApper  </th>
                                                    </tr>
                                                </thead>

                                                {/* ✅ Conditional tbody */}
                                                {selectedValue !== "" ? (
                                                    <tbody>
                                                        {selfAssignedTargetRecords && selfAssignedTargetRecords.length > 0 ? (
                                                            selfAssignedTargetRecords
                                                                .filter((item) => {
                                                                    const assignedTarget =
                                                                        userType === "2"
                                                                            ? item.centralMission
                                                                            : userType === "3"
                                                                                ? item.districtMission
                                                                                : userType === "4"
                                                                                    ? item.subDistrictMission
                                                                                    : 0;

                                                                    // ✅ Hide row if assigned target is 0 / null
                                                                    return item.userTypeCode != userType && assignedTarget > 0;
                                                                })

                                                                .map((item, index) => {
                                                                    const assignedTarget =
                                                                        userType === "2"
                                                                            ? item.centralMission
                                                                            : userType === "3"
                                                                                ? item.districtMission
                                                                                : userType === "4"
                                                                                    ? item.subDistrictMission
                                                                                    : 0;

                                                                    // ✅ Calculate completeValue HERE (correct scope)
                                                                    const report = assignTargetReports.find(
                                                                        (r) =>
                                                                            r.stateCode === item.stateCode &&
                                                                            r.targetType === item.schemeSubTypeName
                                                                    );

                                                                    const completeValue = report ? report.totalSurveyArea : 0;

                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{item.schemeSubTypeName || "-"}</td>

                                                                            {/* Assigned Target */}
                                                                            <td>{assignedTarget + " " + item.uomType}</td>

                                                                            {/* Physical Achievement */}
                                                                            <td>
                                                                                <div className="d-flex">
                                                                                    <div className="input-group" style={{ width: "160px" }}>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control"
                                                                                            value={
                                                                                                activeRow === index
                                                                                                    ? inputValue
                                                                                                    : achievedValues[index] !== undefined
                                                                                                        ? achievedValues[index]
                                                                                                        : item.physicalAchievment || 0
                                                                                            }
                                                                                            onFocus={() => {
                                                                                                setActiveRow(index);                    // 👈 focus pe active row set
                                                                                                setInputValue(
                                                                                                    achievedValues[index] ??
                                                                                                    item.physicalAchievment ??
                                                                                                    0
                                                                                                );
                                                                                            }}
                                                                                            onChange={(e) => setInputValue(e.target.value)}
                                                                                            onBlur={() => setActiveRow(null)}         // 👈 focus hatne par hide
                                                                                        />
                                                                                        <span className="input-group-text" style={{ background: "#eee" }}>
                                                                                            {item.uomType || ""}
                                                                                        </span>
                                                                                    </div>

                                                                                    {/* ✅ Button only when input is active */}
                                                                                    {activeRow === index && (
                                                                                        <button
                                                                                            className="btn btn-success ms-2"
                                                                                            onMouseDown={() => handleSubmitAchieved(index, item)}
                                                                                        >
                                                                                            Update
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            </td>


                                                                            {/* Complete Value */}
                                                                            <td>{completeValue} {item.uomType}</td>
                                                                        </tr>
                                                                    );
                                                                })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">
                                                                    No records found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>

                                                ) : (
                                                    <tbody>
                                                        {selfAssignedTargetRecords && selfAssignedTargetRecords.length > 0 ? (
                                                            selfAssignedTargetRecords
                                                                .filter((item) => {
                                                                    const assignedTarget =
                                                                        userType === "2"
                                                                            ? item.centralMission
                                                                            : userType === "3"
                                                                                ? item.districtMission
                                                                                : userType === "4"
                                                                                    ? item.subDistrictMission
                                                                                    : 0;

                                                                    // ✅ Hide row if assigned target is 0 / null
                                                                    return item.userTypeCode != userType && assignedTarget > 0;
                                                                })

                                                                .map((item, index) => {
                                                                    const assignedTarget =
                                                                        userType === "2"
                                                                            ? item.centralMission
                                                                            : userType === "3"
                                                                                ? item.districtMission
                                                                                : userType === "4"
                                                                                    ? item.subDistrictMission
                                                                                    : 0;

                                                                    // ✅ Calculate completeValue HERE (correct scope)
                                                                    const report = assignTargetReports.find(
                                                                        (r) =>
                                                                            r.stateCode === item.stateCode &&
                                                                            r.targetType === item.schemeSubTypeName
                                                                    );

                                                                    const completeValue = report ? report.totalSurveyArea : 0;

                                                                    return (
                                                                        <tr key={index}>
                                                                            <td>{index + 1}</td>
                                                                            <td>{item.schemeSubTypeName || "-"}</td>

                                                                            {/* Assigned Target */}
                                                                            <td>{assignedTarget + " " + item.uomType}</td>

                                                                            {/* Physical Achievement */}
                                                                            <td>
                                                                                <div className="d-flex">
                                                                                    <div className="input-group" style={{ width: "160px" }}>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control"
                                                                                            value={
                                                                                                activeRow === index
                                                                                                    ? inputValue
                                                                                                    : achievedValues[index] !== undefined
                                                                                                        ? achievedValues[index]
                                                                                                        : item.physicalAchievment || 0
                                                                                            }
                                                                                            onFocus={() => {
                                                                                                setActiveRow(index);                    // 👈 focus pe active row set
                                                                                                setInputValue(
                                                                                                    achievedValues[index] ??
                                                                                                    item.physicalAchievment ??
                                                                                                    0
                                                                                                );
                                                                                            }}
                                                                                            onChange={(e) => setInputValue(e.target.value)}
                                                                                            onBlur={() => setActiveRow(null)}         // 👈 focus hatne par hide
                                                                                        />
                                                                                        <span className="input-group-text" style={{ background: "#eee" }}>
                                                                                            {item.uomType || ""}
                                                                                        </span>
                                                                                    </div>

                                                                                    {/* ✅ Button only when input is active */}
                                                                                    {activeRow === index && (
                                                                                        <button
                                                                                            className="btn btn-success ms-2"
                                                                                            onMouseDown={() => handleSubmitAchieved(index, item)}
                                                                                        >
                                                                                            Update
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            </td>


                                                                            {/* Complete Value */}
                                                                            <td>{completeValue} {item.uomType}</td>
                                                                        </tr>
                                                                    );
                                                                })
                                                        ) : (
                                                            <tr>
                                                                <td colSpan="5" className="text-center">
                                                                    No records found
                                                                </td>
                                                            </tr>
                                                        )}
                                                    </tbody>




                                                )}
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}

                    </div>
                </section>
                {showModal && sessionStorage.getItem("userRoleCodeModel") === "2" && (
                    <div className="modal fade show d-block edittargrt" tabIndex="-1" role="dialog">
                        <div className="modal-dialog modal-lg" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">Target Revised By State</h5>

                                </div>
                                <div className="modal-body">
                                    <p>For the <b className="helights"> Financial Year {finYear}, </b>  target of <b className="helights"> {summaryString} surveys </b> under the <b className="helights"> {currentSchemeName}</b> scheme has been assigned to the state of
                                        <b className="helights"> {currentStateName} </b> by the Central Government. You have the option to revise this target and set it as per your preference. However,
                                        If you choose not to revise it, you will have to work with the target
                                        assigned by the Central Government. So, would you like to revise your target?</p>


                                    <div class="col-md-12 d-flex justify-content-md-center mt-3">
                                        <button
                                            type="button"
                                            className="btn btn-success farmrbtn me-2"
                                            onClick={() => {
                                                setShowTargetInput(true);
                                                setIsYesButtonDisabled(true);
                                            }}
                                            disabled={isYesButtonDisabled}
                                        >
                                            Yes
                                        </button>
                                        <button type="button" className="btn btn-success me-md-2" onClick={() => handleSubmit(1)} >No</button>
                                    </div>


                                    {showTargetInput && (
                                        <div className="col-md-12 mt-3">
                                            {missionTargetSummary && missionTargetSummary.length > 0 ? (
                                                missionTargetSummary.map((item, idx) => (
                                                    <div key={idx} className="row align-items-center mb-2">
                                                        <label className="col-md-4 col-form-label">
                                                            {item.schemeSubTypeName}
                                                        </label>
                                                        <div className="col-md-6">
                                                            <input
                                                                type="text"
                                                                className="form-control targetinput"
                                                                name={`revisedTarget_${idx}`}
                                                                placeholder="000000"
                                                                value={inputValues[idx]?.revisedTargetByState || ''}
                                                                onChange={e => handleChange(idx, e.target.value)}
                                                            />
                                                        </div>
                                                    </div>
                                                ))
                                            ) : (
                                                <div>No mission target summary available.</div>
                                            )}
                                            <div className="d-flex justify-content-md-center mt-3">
                                                <button type="button" className="btn btn-success farmrbtn me-2" onClick={() => {
                                                    // Update missionTargetSummary with input values
                                                    const updated = missionTargetSummary.map((item, idx) => ({
                                                        ...item,
                                                        revisedTarget: inputValues[idx] || ''
                                                    }));

                                                    handleSubmit(2);
                                                }}>
                                                    Revise Target
                                                </button>
                                            </div>
                                        </div>
                                    )}

                                </div>

                            </div>
                        </div>
                        <div className="modal-backdrop fade show"></div>
                    </div>
                )}


            </main>

            <AdminFooterNew />
        </>
    );
}

export default SelfAssignTargetMNT;